import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';

import {
    getConfItem,
    getLabel,
    getQuotationsTitle
} from '../../../conf/conf';

import { connect } from "react-redux";
import appStore from '../../../redux/store/appStore';
import {
    updateGui,
    updateQuotations,
    updateQuotationsSnapshot,
    updateQuotationsTotal,
    updateQuotationsOption,
    updateQuotationsSelectedQuotation,
    updateQuotationsSelectedImpianto,
    updateBestquotations,
    updateBatteries,
    updateAltquotations
} from '../../../redux/actions/actions';

import {
    config as httpClientConfig,
    quotationsGet as httpClientQuotationsGet
} from '../../../libs/http-client';
import { quotationsGetRequestData } from '../../../libs/http-client-dataManager';

import Header from '../../Header';
import Loading from '../../Loading';
import InstallationQuotations from './InstallationQuotations';
import Form from './Form';

import { gaTrackPage } from '../../../helpers/google-analytics-helper';
import {
    urlRewriteWithSearchStringFromState,
    currentUrlAddSearchString
} from '../../../helpers/browser-navigation-helper';
import { mapImageUrlInReactComponent } from '../../../helpers/google-map-helper';
import { pageComponentCssClass } from '../../../helpers/components-helper';
import {
    format,
    priceStringToFloat,
    priceStringFormat,
    floatStringFormat,
    formatProduzioneAnnualeGarantita
} from '../../../helpers/currency-helper';

import {
    quotationTypeFromOptionId,
    optionNameFromOptionId,
    getTotaleBySelection,
    getImpiantoBySelection,
    getOptionsSelectionState,
    getProduzioneAnnualeGarantitaWithOttimizzatori,
    readQuotationFromReduxStateByInputsSnapshot
} from '../../../helpers/quotations-helper';
import { getItem } from '../../../helpers/object-helper';

import AnimatedTyping from '../../../libs/animatedTyping';

import './PageQuotations.css';

const mapStateToProps = state => {
    return {
        gui: state.gui,
        quotations: state.quotations
    };
};

const imgLabelsDummyUrl = '/images/quotations-labels-dummy.jpg';

const quotationsConfig = {
    sistemaSolare: {
        label: 'Impianto Fotovoltaico'
    },
    potenza: {
        label: 'Impianto ftv da',
        valueGuiFn: value => floatStringFormat(value, 'kWp')
    },
    capacitaSistemaAccumulo: {
        label: 'Sistema di Accumulo Energia',
        guiHtmlElementTypes: {
            basic: 'HtmlLabel',
            plus: 'HtmlPlusMinus'
        },
        valueGuiFn: value => (value === getConfItem('altquotations.featureNotAvailableValue') ? value : floatStringFormat(value, 'kWh')),
    },
    /**
    numeroPannelliMax: {
        label:'Massimo numero di pannelli installabili',
        values: {
            basic: '[Read from Application State]',
            plus: '[Read from Application State]',
        },
        valueGuiFn: (value, options) => {
            return getMaxNumeroPannelli(options.quotationType);
        }
    },

     */
    numeroPannelli: {
        label: 'Numero pannelli',
        guiHtmlElementTypes: {
            basic: 'HtmlPlusMinus',
            plus: 'HtmlPlusMinus'
        }
    },
    tipoPannelli: {
        label: 'Tipo pannelli',
        values: {
            basic: 'Monocristallino',
            plus: 'Monocristallino'
        }
    },
    ottimizzatori: {
        label: 'Aggiungi ottimizzatori di potenza',
        guiHtmlElementTypes: {
            basic: 'HtmlCheckbox',
            plus: 'HtmlCheckbox'
        }
    },
    produzioneAnnualeGarantita: {
        label: 'Energia prodotta in un anno',
                /**
         * produzioneAnnualeGarantita value depends on ottimizzatori selection
         * @param {String} value 
         * @param {Object} options 
         *  .quotationType {String}
         *  .values {Object}
         *      .basic {String}
         *          Sample: "4.660 kWh annuo"
         *      .basicWithOttimizzatori {String}
         *      .plus {String}
         *      .plus-s {String}
         *      .plusWithOttimizzatori {String}
         *  .inputsSnapshot {Object}
         *      .accumulatoreProposto
         *          .basic {Boolean}
         *          .plus {Boolean}
         *      .ottimizzatori
         *          .plus {Boolean}
         *      .numeroPannelli
         *          .basic {Number}
         *          .plus {Number}
         *      .capacitaSistemaAccumulo
         *          .basic {String}
         *          .plus {String}
         */
        valueGuiFn: (value, options) => {
            const quotationType = options.quotationType;
            const values = options.values;
            const ottimizzatoriSelected = options.inputsSnapshot.ottimizzatori[quotationType];
            const valueKey = (ottimizzatoriSelected) ? quotationType + 'WithOttimizzatori' : quotationType; // 'basic'|'basicWithOttimizzatori'|'plus'|'plusWithOttimizzatori'
            value = values[valueKey]; // '6.000/kWh annuo'|6.300/kWh annuo
            return formatProduzioneAnnualeGarantita(value);
        }
    },
    /*
    accumulatoreProposto: {
        label: 'Aggiungi Batteria'
    },
    */
    totale: {
        label: 'Totale (IVA 10% inclusa)',
        valueGuiFn: (value) => priceStringFormat(value)
    },
    totaleCessioneCredito: {
        label: 'Detrazione fiscale 50%'
    },
    scegli: {
        label: '',
        values: {
            basic: null,
            plus: null
        },
        guiHtmlElementTypes: {
            basic: 'HtmlButton',
            plus: 'HtmlButton'
        }
    },
};

class PageQuotations extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            mapStaticImageUrl: null,
            loading: false,
            config: quotationsConfig,
            valutazione: null,  // quotationsResponse.valutazione
            data: null,         // quotationsResponse.quotations
            totals: null        // will store the totals table, cloning it quotationsResponse.quotations.totale
        };
    }

    componentDidMount() {

        // update current url with search string
        currentUrlAddSearchString();

        // dispatch current step title
        appStore.dispatch(updateGui({
            currentStepTitle: getQuotationsTitle()
        }));

        // set map static image url
        this.setMapStaticImageUrl();

        // request quotations to http web api
        httpClientConfig({
            baseUrl: getConfItem('api.' + process.env.NODE_ENV + '.baseUrl')
        });
        this.fetchQuotations();

        // Google Analytics track page
        gaTrackPage();
    }

    /**                                                                              Redirect
     * ======================================================================================
     */

    /**
     * Navigates back to Wizard Step 9
     */
    navigateBack() {
        this.setState((state, props) => ({
            redirect: urlRewriteWithSearchStringFromState('wizard/step9')
        }));
    }

    /**
     * Navigates back to Wizard Step 1
     */
    navigateToWizard() {
        this.setState((state, props) => ({
            redirect: urlRewriteWithSearchStringFromState('wizard/step1')
        }));
    }


    /**                                                                                  Data
     * ======================================================================================
     */

    /**
     * Triggers quotations fetch from the SolarConfig API
     */
    fetchQuotations() {
        this.setState((state, props) => ({
            loading: true
        }));
        httpClientQuotationsGet(quotationsGetRequestData())
            /**
             * @param {Object} response
             *  .config (axios config)
             *  .data (actual data)
             *  .headers (http headers)
             *  .request (xmlhttp)
             */
            .then(function(response) {
                ////console.log('httpClientQuotationsGet(), response ', response);
                this.onFetchQuotationsResponse(response.data);
            }.bind(this));
    }

    /**
     * Fetch quotations response handler
     * @param {Object} response 
     */
    onFetchQuotationsResponse(response) {

        ////console.log('PageQuotations.onFetchQuotationsResponse()');

        // switch loading to false
    
        this.setState((state, props) => ({
            loading: false
        }));

        // read response data
        const uuid = response.uuid;
        const valutazione = response.valutazione;
        const quotations = response.quotations;
        const altquotations = response.altquotations;
        const bestquotationsRef = response.bestquotations;
        const bestquotations = response[bestquotationsRef];
        const batteries = response.batteries;

        ////console.log('RESPONSE = ', response);

        /**
         * update application store quotations (.quotations) with response data info
         * ...for checkbox options, we need a boolean indicating if the option has been choosen, not the option cost
         * ...this is why we assign false here and not the value (the cost) stored in the response
         */
        this.updateStoreQuotations(quotations, {
            uuid,
            valutazione
        });

        // update application store altquotations (.altquotations) with response data
        appStore.dispatch(updateAltquotations({
            altquotations: altquotations
        }));

        // update application store bestquotations (.bestquotations) with response data
        appStore.dispatch(updateBestquotations({
            bestquotations
        }));

        // update application store batteries (.batteries) with response data
        appStore.dispatch(updateBatteries({
            batteries
        }));
        

        // update state (this.state.valutazione, this.state.data) with response data

        this.setState((state, props) => {
            return {
                valutazione,
                data: {
                    ...quotations,
                    produzioneAnnualeGarantita: {
                        ...quotations.produzioneAnnualeGarantita,
                        ...getProduzioneAnnualeGarantitaWithOttimizzatori(quotations.produzioneAnnualeGarantita)

                    },
                    totaleCessioneCredito: {
                        basic: this.getTotaleCessioneCreditoFromTotal(quotations.totale.basic),
                        plus: this.getTotaleCessioneCreditoFromTotal(quotations.totale.plus)

                    }
                },
                totals: {...quotations.totale}
            };
        });

    }

    /**
     * Returns totalCessioneCredito from total
     * Must divide total/2
     * Converts total string to float (priceStringToFloat), executes the division and reconverts the result to string again (format)
     * @param {String} total
     *  Sample
     *      '7.381,9'
     * @return {Float}
     *  Sample
     *      3690.95
     */
    getTotaleCessioneCreditoFromTotal(total) {
        return format(priceStringToFloat(total) / 2);
    }

    /**
     * Updates the Component state
     * @param {Object} quotations 
     * @param {Object} options
     *  .valutazione {Object} optional
     */
    updateState(quotations, options = {}) {

        this.setState((state, props) => {

            // valutazione, if not passed in, gets the redux store value
            const valutazione = options.valutazione || props.quotations.valutazione;

            return {
                valutazione: valutazione,
                data: {
                    ...quotations,
                    produzioneAnnualeGarantita: {
                        ...quotations.produzioneAnnualeGarantita,
                        ...getProduzioneAnnualeGarantitaWithOttimizzatori(quotations.produzioneAnnualeGarantita)
                    },
                    totaleCessioneCredito: {
                        basic: this.getTotaleCessioneCreditoFromTotal(quotations.totale.basic),
                        plus: this.getTotaleCessioneCreditoFromTotal(quotations.totale.plus)
                    }
                },
                totals: {...quotations.totale}
            };

        });
    }

    /**
     * Updates quotations totale in Component state (this.state.data.totale)
     * @param {String} quotationType 
     *  Range
     *      ['basic'|'plus']
     * @param {String} Number 
     */
    updateStateTotale(quotationType, value) {
        this.setState((state, props) => {

            const updateObj = {
                data: {
                    totale:{},
                    totaleCessioneCredito:{}
                }
            };
            updateObj.data.totale[quotationType] = value;
            updateObj.data.totaleCessioneCredito[quotationType] = this.getTotaleCessioneCreditoFromTotal(value);

            const updateTotale = {
                ...state.data.totale,
                ...updateObj.data.totale
            };
            const updateTotaleCessioneCredito = {
                ...state.data.totaleCessioneCredito,
                ...updateObj.data.totaleCessioneCredito
            };

            return {
                ...state,
                data: {
                    ...state.data,
                    totale: updateTotale,
                    totaleCessioneCredito: updateTotaleCessioneCredito
                }
            };
        });
    }

    /**
     * Update the application store quotations (.quotations) with quotations
     * uuid and valutazione are passed in only on /quote service response load, then just read again from the application store
     * For checkbox options (accumulatoreProposto, ottimizzatori), we need a boolean indicating if the option has been choosen, not the option cost
     * This is why we assign it to the redux store value (which is always boolean) if the option is received as !boolean (backend must be updated to send boolean type)
     * @param {Object} quotations 
     * @param {Object} options 
     *  .valutazione {Object} optional
     *      Passed in only on /quote service response load
     *  .uuid {String} optional
     *      Passed in only on /quote service response load
     */
    updateStoreQuotations(quotations, options = {}) {

        // quotations fields evaluated with the redux store value, if not received as arguments
        const uuid = options.uuid || this.props.quotations.uuid;
        const valutazione = options.valutazione || this.props.quotations.valutazione;
        const selectedImpianto = options.selectedImpianto || this.props.quotations.selectedImpianto;
        const selectedQuotation = options.selectedQuotation || this.props.quotations.selectedQuotation;

        // add produzioneAnnualeGarantitaWithOttimizzatori
        quotations.produzioneAnnualeGarantita = {
            ...quotations.produzioneAnnualeGarantita,
            ...getProduzioneAnnualeGarantitaWithOttimizzatori(quotations.produzioneAnnualeGarantita)
        };

        appStore.dispatch(updateQuotations({
            quotations: {
                uuid,
                valutazione,
                selectedImpianto,
                selectedQuotation,
                snapshot: quotations,
                basic: {
                    total: quotations.totale.basic,
                    options: {
                        numeroPannelli: quotations.numeroPannelli.basic,
                        capacitaSistemaAccumulo: quotations.capacitaSistemaAccumulo.basic,
                        ottimizzatori: (typeof(quotations.ottimizzatori.options.basic) === 'boolean') ? quotations.ottimizzatori.options.basic : this.props.quotations.basic.options.ottimizzatori
                    }
                },
                plus: {
                    total: quotations.totale.plus,
                    options: {
                        numeroPannelli: quotations.numeroPannelli.plus,
                        capacitaSistemaAccumulo: quotations.capacitaSistemaAccumulo.plus,
                        ottimizzatori: (typeof(quotations.ottimizzatori.options.plus) === 'boolean') ? quotations.ottimizzatori.options.plus : this.props.quotations.plus.options.ottimizzatori
                    }
                }
            }
        }));

    }
    
    /**
     * Updates quotations snapshot in application store (.quotations.snapshot)
     * @param {Object} quotationsSnapshot
     */
    updateStoreQuotationsSnapshot(quotationsSnapshot) {
        appStore.dispatch(updateQuotationsSnapshot({
            snapshot: quotationsSnapshot
        }));      
    }
    

    /**
     * Updates quotations totale and options in application store
     * @param {String} quotationType
     *  Range
     *      ['basic'|'plus']
     * @param {Number} totalValue
     *  Sample
     *      12901.39
     * @param {String} optionId
     *  Sample
     *      'accumulatoreProposto'
     * @param {Boolean} optionValue 
     */
    updateStoreOptionsAndTotale(quotationType, totalValue, optionId, optionValue) {

        appStore.dispatch(updateQuotationsTotal({
            quotationType: quotationType,
            totalValue: totalValue
        })); 

        appStore.dispatch(updateQuotationsOption({
            quotationType: quotationType,
            optionId: optionId,
            optionValue: optionValue
        })); 

    }

    /**
     * Updates quotations selected quotation in application store (.quotations.selectedQuotation)
     * @param {String} quotationType
     *  Range
     *      ['basic'|'plus']
     */
    updateStoreSelectedQuotation(quotationType) {
        appStore.dispatch(updateQuotationsSelectedQuotation({
            quotationType: quotationType
        }));        
    }

    /**
     * Updates quotations selected impianto in application store (.quotations.selectedImpianto)
     * @param {String} impianto
     *  Range
     *      ['basic'|'basic-s'|'plus'|'plus-s']
     */
    updateStoreSelectedImpianto(impianto) {
        appStore.dispatch(updateQuotationsSelectedImpianto({
            impianto: impianto
        }));        
    }

    /**
     * Sets this.state.mapStaticImageUrl driven by the application store
     */
    setMapStaticImageUrl() {
        const appState = appStore.getState();
        const map = getItem('map.refs.map', appState);
        const polygon = getItem('map.refs.polygon', appState);
        const responsiveState = getItem('gui.responsive', appState);
        const mapImageViewport = getConfItem('gui.map.mapStaticImage.sizeInQuotationsComponent');//'331x204';
        const mapImageUrl = mapImageUrlInReactComponent(map, polygon, responsiveState, mapImageViewport);
        this.setState((state, props) => ({
            mapStaticImageUrl: mapImageUrl || imgLabelsDummyUrl
        }));
    }

    /**                                                                                Events
     * ======================================================================================
     */

    onQuoteChooseButtonClick(evt) {

        const selectedClassName = 'slc-button-quotation-selected';

        // is the checkbox selected?
        ////console.log(evt.target);
        const selected = evt.target.classList.contains(selectedClassName);//evt.target.checked;

        // parent element to read important infos from parent element attributes
        const parent = evt.target.parentElement;

        // id of the checkbox (containes both the quotation type and the option name)
        const dataOptionId = parent.getAttribute('data-option-id');                         // Sample: 'ottimizzatori-basic'

        // the quotation type ('basic')
        const quotationType = quotationTypeFromOptionId(dataOptionId);                      // sample: 'basic'

        ////console.log('selected = ', selected);
        ////console.log('dataOptionId = ', dataOptionId);
        ////console.log('quotationType = ', quotationType);
        
        // unselect if already selected
        if (selected) {

            // update selected quotation model and gui
            evt.target.classList.remove(selectedClassName);

            // update the application store selected quotation
            const selectedQuotation = null;
            this.updateStoreSelectedQuotation(selectedQuotation);

            // update the Gui quotation selector choose buttons
            // this.quotationSelectorCheckboxesGui(dataOptionId, selected); FOR CHECKBOXES, MUST BE IMPLEMENTED FOR CHOOSE BUTTONS
            this.quotationSelectorChooseButtonsGui(dataOptionId, false, selectedClassName);

            // update the cessioneDelCredito values gui, depending on the selected quotation type
            this.cessioneDelCreditoValuesGui(false, quotationType);

            // update form emphasize gui
            this.formEmphasizeManageGui(selectedQuotation);

        // select if not selected
        } else {

            // update selected quotation model and gui
            evt.target.classList.add(selectedClassName);

            // update the application store selected quotation
            const selectedQuotation = quotationType;
            this.updateStoreSelectedQuotation(selectedQuotation);

            // update the Gui quotation selector choose buttons
            // this.quotationSelectorCheckboxesGui(dataOptionId, selected); FOR CHECKBOXES, MUST BE IMPLEMENTED FOR CHOOSE BUTTONS
            this.quotationSelectorChooseButtonsGui(dataOptionId, true, selectedClassName);

            // update the cessioneDelCredito values gui, depending on the selected quotation type
            this.cessioneDelCreditoValuesGui(true, quotationType);

            // update form emphasize gui
            this.formEmphasizeManageGui(selectedQuotation);
        }

        // update the application store selected impianto
        // get the selected quotation/column (basic)
        const selectedQuotation = getItem('quotations.selectedQuotation', appStore.getState());
        // if no quotation is selected, selected impianto is null also
        if (selectedQuotation === null) {
            this.updateStoreSelectedImpianto(null);
        // if some quotation is selected
        } else {
            // if the user interacted option checkbox belongs to the selected quotation/column, calculate selected impianto based on the user choices
            if (quotationType === selectedQuotation) {
                let selectedImpianto = getImpiantoBySelection(quotationType, getOptionsSelectionState());
                this.updateStoreSelectedImpianto(selectedImpianto);
            }
        }
    }

    /**
     * Event listener for quotations checkbox options
     * @param {Event} evt 
     */
    onCheckboxChange(evt) {

        // is the checkbox selected?
        const selected = evt.target.checked;

        // parent element to read important infos from parent element attributes
        const parent = evt.target.parentElement;

        // id of the checkbox (containes both the quotation type and the option name)
        const dataOptionId = parent.getAttribute('data-option-id');                         // Sample: 'ottimizzatori-basic'

        // the quotation type ('basic')
        const quotationType = quotationTypeFromOptionId(dataOptionId);                      // sample: 'basic'

        // is the checkbox a quotation selector or a quotation update one?
        const isQuotationSelector = parent.getAttribute('class').indexOf('scegli') != -1;

        // a row 'Scegli il tuo sistema' checkbox was checked -> select quotation
        if (isQuotationSelector) {

            // update the application store selected quotation
            const selectedQuotation = (selected) ? quotationType : null ;
            this.updateStoreSelectedQuotation(selectedQuotation);

            // update the Gui quotation selector checkboxes
            this.quotationSelectorCheckboxesGui(dataOptionId, selected);

            // update the cessioneDelCredito values gui, depending on the selected quotation type
            this.cessioneDelCreditoValuesGui(selected, quotationType);

            this.formEmphasizeManageGui(selectedQuotation);
                
        // a value checkbox was checked -> update quotations
        } else {

            const optionName = optionNameFromOptionId(dataOptionId);                        // Sample: 'ottimizzatori'                       
            const totalUpdated = getTotaleBySelection(dataOptionId, this.state.totals);

            // update this.state.data.totale
            this.updateStateTotale(quotationType, totalUpdated);
            this.updateStoreOptionsAndTotale(quotationType, totalUpdated, optionName, selected);

            // if the checkbox is 'ottimizzatori', update the Produzione Annuale Garantita value accordingly
            if (optionName === 'ottimizzatori') {
                this.produzioneAnnualeGarantitaFromOttimizzatori(quotationType, selected);
            }

        }

        // update the application store selected impianto
        // get the selected quotation/column (basic)
        const selectedQuotation = getItem('quotations.selectedQuotation', appStore.getState());
        // if no quotation is selected, selected impianto is null also
        if (selectedQuotation === null) {
            this.updateStoreSelectedImpianto(null);
        // if some quotation is selected
        } else {
            // if the user interacted option checkbox belongs to the selected quotation/column, calculate selected impianto based on the user choices
            if (quotationType === selectedQuotation) {
                let selectedImpianto = getImpiantoBySelection(quotationType, getOptionsSelectionState());
                this.updateStoreSelectedImpianto(selectedImpianto);
            }
        }
        
    }

    /**
     * Event listener for quotations select options
     * @param {Event} evt 
     */
    onSelectChange(evt) {

        // parent element to read important infos from parent element attributes
        const parent = evt.target.parentElement;

        // id of the checkbox (containes both the quotation type and the option name)
        const dataOptionId = parent.getAttribute('data-option-id');                         // Sample: 'ottimizzatori-plus'

        // the quotation type ('basic'|'plus')
        const quotationType = quotationTypeFromOptionId(dataOptionId);                      // sample: 'plus'

        // the data id                                                                      // sample: 'numeroPannelli
        const dataId = optionNameFromOptionId(dataOptionId);

        // find the quotations determined by the current inputs snapshot (which choices the user has done with the quotations inputs, if any)
        const quotations = readQuotationFromReduxStateByInputsSnapshot(appStore.getState(), quotationType);
        
        // Update Redux store quotations.snapshot with found quotations
        this.updateStoreQuotations(quotations);

        // Update Component state with quotations
        this.updateState(quotations);

        // Update Component state totale with quotation
        const totalUpdated = getTotaleBySelection(dataOptionId, quotations.totale);
        this.updateStateTotale(quotationType, totalUpdated);
        
    }

    /**
     * Click event handler for the full page
     * Clicking anywhere in the page causes deleting the currently shown label info popup, if any
     * This function is passed down to child components as a prop:
     *  1. 'this' will be the ref to the leaf components (QuotationsDesktop.js, QuotationsMobile.js)
     *  2. the addEventListener function is actually registered in the leaf components (QuotationsDesktop.js, QuotationsMobile.js)
     * Deletion occurs if:
     *  1. Click occurred on any element except 
     *      .slc-data-label-info
     *      .slc-data-label-info-content__body
     *      in which case, deletion is already managed by the click handlers on those elements
     *  2. A label info popup is currently shown
     * @param {Event} evt 
     */
    onLabelInfoClickAnywhere(evt) {
        // get the target css class name
        const className = evt.target.getAttribute('class');
        // if target is any element except .slc-data-label-info and .slc-data-label-info-content__body, proceed
        if (className !== 'slc-data-label-info' && className !== 'slc-data-label-info-content__body') {
            // if any label info is shown, delete it
            if (this.labelInfoShowedNow) {
                this.labelInfoContentDelete(this.labelInfoShowedNow);
            }
        }
    }

    /**                                                                                   Gui
     * ======================================================================================
     */

    quotationEmphasizeGui(quotationType) {}

    domGetMainElement() {
        return document.querySelector('.slc-page-quotations-main');
    }

    domGetFormElement() {
        return document.querySelector('.slc-page-quotations-form');
    }

    /**
     * Handles the form emphasize/unemphasize Gui
     * When a quote is selected, the form is emphasized
     * When a quote is unselected, the form is unemphasized
     * @param {String} selectedQuotation 
     *  ['basic'|'plus']
     */
    formEmphasizeManageGui(selectedQuotation) {
        const formElement = this.domGetFormElement();
        const mainElement = this.domGetMainElement();
        if (selectedQuotation) {
            this.formEmphasizeGui(mainElement, formElement);
        } else {
            this.formUnemphasizeGui(mainElement, formElement);
        }
    }

    /**
     * Emphasizes the form Gui
     * 1. Shrinks the main pane from l12 to l8 width
     * 2. Shows the form pane
     * 3. Scrolls the page to the form pane
     * 4. Animates the form title as text typing
     * 5. Put focus onto the form's name text field
     * @param {HTMLElement} mainElement 
     * @param {HTMLElement} formElement 
     */
    formEmphasizeGui(mainElement, formElement) {
        // 1.
        const mainClass = mainElement.getAttribute('class').replace('l12', 'l8');
        mainElement.setAttribute('class', mainClass);
        // 2.
        const formClass = formElement.getAttribute('class').replace('hide', '');
        formElement.setAttribute('class', formClass);
        // 3.
        formElement.scrollIntoView();
        // 4.
        /* Uncomment this to enable the Form title animation (must remove the text from the Form Component title, also)
        const formTitleElement = document.querySelector('.slc-quotations-form__title');
        const formTitleAnimation = new AnimatedTyping('Inserisci i tuoi dati per ricevere un preventivo dettagliato su misura per te', {speed: 50}, function(txt, fullTxt, options) {
            formTitleElement.innerHTML = txt;
        }).animate();
        */
        // 5.
        const inputNameElement = document.querySelector('.slc-form-input-text-widget__input-nome');
        inputNameElement.focus();
    }

    /**
     * Unmphasizes the form Gui
     * Does not need any implementation so far
     * @param {HTMLElement} mainElement 
     * @param {HTMLElement} formElement 
     */
    formUnemphasizeGui(mainElement, formElement) {
        ////console.log('PageQuotations.formUnemphasizeGui()');
    }

    /**
     * Sets the selectedButtonId button to selected state
     * Deselects all the other 'scegli-...' buttons
     * 
     * Updates form validation related features:
     *  - if selected === true:
     *      - removes the gui invalid view
     *      - triggers form submit button state manager
     */
    quotationSelectorChooseButtonsGui(selectedButtonId, selected, selectedClassName) {

        document.querySelectorAll('[data-option-id^="scegli-"] .slc-button')
            .forEach(function(button) {
                let buttonId = button.parentElement.getAttribute('data-option-id');
                if (buttonId == selectedButtonId) {
                    if (selected) {
                        button.classList.add(selectedClassName);
                    } else {
                        button.classList.remove(selectedClassName);
                    }
                } else {
                    button.classList.remove(selectedClassName);
                }
            });

        if (selected) {
            const formGuiValidationElement = document.querySelector('.slc-data-scegli');
            formGuiValidationElement.classList.remove('slc-form-item-validation-error');
        }
        
    }

    /**
     * Sets the selectedCheckboxId checkbox checked state to selected
     * Deselects all the other 'scegli-...' checkboxes
     * 
     * Updates form validation related features:
     *  - if selected === true:
     *      - removes the gui invalid view
     *      - triggers form submit button state manager
     */
    quotationSelectorCheckboxesGui(selectedCheckboxId, selected) {

        document.querySelectorAll('[data-option-id^="scegli-"] .slc-checkbox')
            .forEach(function(checkbox) {
                let checkboxId = checkbox.parentElement.getAttribute('data-option-id');
                if (checkboxId == selectedCheckboxId) {
                    checkbox.checked = selected;
                } else {
                    checkbox.checked = false;
                }
            });

        if (selected) {
            const formGuiValidationElement = document.querySelector('.slc-data-scegli');
            formGuiValidationElement.classList.remove('slc-form-item-validation-error');
        }
        
    }

    /**
     * Updates the cessioneDelCredito values gui, depending on the selected quotation type
     * Hilites the selected quotation value
     * Dehilites the other quotation value
     * @param {Boolean} selected 
     * @param {String} quotationType 
     *  ['basic'|'plus']
     */
    cessioneDelCreditoValuesGui(selected, quotationType) {

        const $cessioneDelCreditoValues = document.querySelectorAll('.slc-data-totaleCessioneCredito .slc-data-value');

        // cessione del credito DOM elements don't exist
        if ($cessioneDelCreditoValues.length === 0) {
            return;
        }

        // css class affecting the HTML elements gui
        const selectedCssClassName = 'slc-data-value-selected';
        // dehiltes all the values (basic)
        $cessioneDelCreditoValues
            .forEach(function(dataValueElement) {
                dataValueElement.classList.remove(selectedCssClassName);
            });
        // hilites the selected value, if this is the case
        if (selected) {
            const dataValueElement = document.querySelector('.slc-data-totaleCessioneCredito .slc-data-value-' + quotationType);
            dataValueElement.classList.add(selectedCssClassName);
        }
        
    }

    /**
     * Updates the Produzione Annuale Garantita (Energia garantita (5 anni)) gui value based upon if the Ottimizzatori di potenza (Desidero ottimizzatori di potenza) is selected or not
     * The value is fetched from this.state.data.produzioneAnnualeGarantita, reading one of the four keys:
     *  'basic'
     *  'basicWithOttimizzatori'
     * @param {String} quotationType
     *  ['basic'|'plus']
     * @param {Boolean} ottimizzatoriSelected
     */

     produzioneAnnualeGarantitaFromOttimizzatori(quotationType, ottimizzatoriSelected, produzioneAnnualeGarantita) {
        
        /*
        //console.log('produzioneAnnualeGarantitaFromOttimizzatori()');
        //console.log(' -> quotationType = ', quotationType);
        //console.log(' -> ottimizzatoriSelected = ', ottimizzatoriSelected);
        //console.log(' -> this.state.data.produzioneAnnualeGarantita = ', this.state.data.produzioneAnnualeGarantita);
        */

        if (!produzioneAnnualeGarantita) {
            produzioneAnnualeGarantita = this.state.data.produzioneAnnualeGarantita;
        }
        
        const produzioneAnnualeGarantitaElement = document.querySelector('.slc-data-produzioneAnnualeGarantita .slc-data-value-' + quotationType);
        const valueKey = (ottimizzatoriSelected) ? quotationType + 'WithOttimizzatori' : quotationType; // 'basic'|'basicWithOttimizzatori'|'plus'|'plusWithOttimizzatori'
        const value = produzioneAnnualeGarantita[valueKey]; // '6.000/kWh annuo'|6.300/kWh annuo
        
        /*
        //console.log(' -> valueKey = ', valueKey);
        //console.log(' -> value = ', value);
        //console.log(' -> value formatted = ', formatProduzioneAnnualeGarantita(value));
        */
        
        produzioneAnnualeGarantitaElement.innerHTML = formatProduzioneAnnualeGarantita(value); // '6.000,00/kWh annuo'
    }

    /**                                                                                Render
     * ======================================================================================
     */

    /**
     * Returns content based on responsive state
     * At the moment behaves always as a 'desktop' state
     */
    getContent() {

        return (
            <Fragment>
                <div className="col s12 l12 slc-page-quotations-main">

                    <InstallationQuotations
                        loading={ this.state.loading }
                        config = { this.state.config }
                        data = { this.state.data }
                        valutazione = { this.state.valutazione }
                        mapStaticImageUrl = { this.state.mapStaticImageUrl }
                        navigateBack = { this.navigateBack.bind(this) }
                        navigateToWizard = { this.navigateToWizard.bind(this) }
                        onCheckboxChange = { this.onCheckboxChange.bind(this) }
                        onSelectChange={ this.onSelectChange.bind(this) }
                        onQuoteChooseButtonClick = { this.onQuoteChooseButtonClick.bind(this) }
                        onLabelInfoClickAnywhere = { this.onLabelInfoClickAnywhere } />

                </div>
                <div className="col s12 l4 slc-page-quotations-form hide">
                    <Form />
                </div>
            </Fragment>
        );

    }

    /**
     * Returns the page css class name
     * @return {String}
     *  Sample
     *      'slc-page slc-page-quotations responsive-desktop
     */
    pageClassName() {
        return pageComponentCssClass('quotations', this.props.gui.responsive);
    }

    render() {
        ////console.log('    PageQuotations.state', this.state);
        if (this.state.redirect !== false) {
            return <Redirect to={ this.state.redirect } />;
        } else {
            const loading = (this.state.loading) ? <Loading label={ getLabel('gui.loading') } /> : null ;
            return (
                <div className={ this.pageClassName() }>
                    <div className="row slc-page-header">
                        <div className="col s12">
                            <Header />
                        </div>
                    </div>
                    { loading }
                    <div className="row slc-page-body">
                        { this.getContent() }
                    </div>
                    <div className="slc-page-footer">
                        <div className='slc-page-footer__image' />
                    </div>
                </div>
            );
        }
    }

}

export default connect(mapStateToProps)(PageQuotations);

export {
    PageQuotations,
    quotationsConfig
};